import './App.css';
import './page.css';

import tracks from './Tracks';
import MusicPlayerTable from './MusicPlayerTable';

/**
 * TODO: notes!
 * 
 * . visualization options - click to change etc.
 *  - waveform lines
 *  - rotate visual with mouse for back/forward?
 *  - canvas bmp capture every few frames with blur etc.? - behind main visualizer
 * . animate list on filter change
 * . GPU shaders in re-design i.e. gently animating background with shader
 * 
 * . autoplay next mix
 * . autoplay from filtered list
 */

const App = () => {
    const index = new URLSearchParams(window.location.search).get("t");
    
    return (
        <div className="App">
            <header className="App-header">
                <h2>DJ ROASTY - MIX PLAYER</h2>
            </header>
            <MusicPlayerTable tracks={tracks} initialTrack={index} />
            <p className="small footer"><b>DJ mixes contain tracks copyright the original producers, they may not be reproduced publically without permission.</b></p>
        </div>
    );
}

export default App;